import i18next, {Resource} from "i18next";
import {initReactI18next} from "react-i18next";
import dayjs from "dayjs";
import {DEFAULT_LANGUAGE, LANGUAGES, languageSettings} from "./languages";

// Un fichier par langue et par namespace (domaine) : `locales/fr/scada.json` devient
// `resources.fr.scada`. Les fichiers sont embarqués dans le bundle plutôt que chargés à la demande :
// ils pèsent peu, et la traduction est ainsi disponible dès le premier rendu, sans Suspense.
const files = import.meta.glob<{default: Record<string, unknown>}>("./locales/*/*.json", {eager: true});

export const resources: Resource = {};
for (const [path, file] of Object.entries(files)) {
  // Le motif du glob ne ramasse que des fichiers à cette profondeur : un fichier placé ailleurs
  // n'est jamais chargé. Ce contrôle protège seulement la correspondance entre ce motif et la regex.
  const match = path.match(/^\.\/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!match) {
    throw new Error(`Fichier de traduction inattendu (attendu ./locales/<langue>/<namespace>.json) : ${path}`);
  }
  const [, language, namespace] = match;
  resources[language] = {...resources[language], [namespace]: file.default};
}

i18next.on("languageChanged", (language) => {
  dayjs.locale(languageSettings(language).dayjs);
});

// `initAsync: false` : l'initialisation est faite au retour de `init`, sa promesse n'apporte rien.
void i18next.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: Object.keys(LANGUAGES),
  resources,
  ns: Object.keys(resources[DEFAULT_LANGUAGE]),
  defaultNS: "common",
  // Les ressources sont déjà en mémoire : l'initialisation synchrone rend les traductions
  // disponibles avant le premier rendu.
  initAsync: false,
  interpolation: {
    // React échappe déjà les valeurs qu'il affiche.
    escapeValue: false,
  },
});

export default i18next;
